"use strict";
exports.__esModule = true;
exports.UserStatus = exports.MobileTypes = exports.ActivityTypes = void 0;
var ActivityTypes;
(function (ActivityTypes) {
    ActivityTypes[ActivityTypes["UNKNOWN"] = 0] = "UNKNOWN";
    ActivityTypes[ActivityTypes["STATIONARY"] = 1] = "STATIONARY";
    ActivityTypes[ActivityTypes["WALKING"] = 2] = "WALKING";
    ActivityTypes[ActivityTypes["RUNNING"] = 3] = "RUNNING";
    ActivityTypes[ActivityTypes["BICYCLE"] = 4] = "BICYCLE";
    ActivityTypes[ActivityTypes["DRIVING"] = 5] = "DRIVING";
    ActivityTypes[ActivityTypes["PUBLIC_TRANSPORT"] = 6] = "PUBLIC_TRANSPORT";
})(ActivityTypes = exports.ActivityTypes || (exports.ActivityTypes = {}));
var MobileTypes;
(function (MobileTypes) {
    MobileTypes[MobileTypes["UNKNOWN"] = 0] = "UNKNOWN";
    MobileTypes[MobileTypes["ANDROID"] = 1] = "ANDROID";
    MobileTypes[MobileTypes["IOS"] = 2] = "IOS";
    MobileTypes[MobileTypes["WINDOWS"] = 3] = "WINDOWS";
})(MobileTypes = exports.MobileTypes || (exports.MobileTypes = {}));
var UserStatus;
(function (UserStatus) {
    UserStatus["FREE"] = "Free";
    UserStatus["ASSIGNED"] = "Assigned";
    UserStatus["ON_THE_WAY"] = "Started";
    UserStatus["CHECKED_IN"] = "Checked-In";
    UserStatus["LATE"] = "Late";
    UserStatus["ACCEPTED"] = "Accepted";
    UserStatus["ON_BREAK"] = "On-Break";
})(UserStatus = exports.UserStatus || (exports.UserStatus = {}));
//# sourceMappingURL=users.js.map